import React from "react";
import CmsAddBlog from "../cms/AddBlog";

const AddBlogs = () => {
  return <CmsAddBlog motherMenu="Blogs" />;
};

export default AddBlogs;
